import { useEffect } from "react"
import { useDispatch } from "react-redux"

import { insuranceActions } from "../../../../store/insurance"
import TabHeader from "../../tab/TabHeader"
import NotesComponent from "../notes/NotesComponent"
import LiabilityTabControls from "../liability/LiabilityTabControls"
import MedpayDetails from "../medpay/MedpayDetails"
import ItemsCounter from "../Shared/ItemsCounter"

const UmTab = ({ inWorkQ }) => {
    const dispatch = useDispatch()

    useEffect(() => {
        return () => {
            dispatch(insuranceActions.setSearchResult(null))
            dispatch(insuranceActions.setClearAsyncResults(false))
        }
    }, [])

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>UM</h2>
                <ItemsCounter type={'mp_pip_um'}/>
                <NotesComponent noteTypeId={5} inWorkQ={inWorkQ}/>
            </div>
            <LiabilityTabControls folder={'mp_pip_um'} apiCase={'case_mp_pip_um'}/>
        </TabHeader>
        <div>
            <MedpayDetails branch={'um'}/>
        </div>
    </>
}

export default UmTab